// extracted by mini-css-extract-plugin
export default {"module":"quizTwo_module__tNnax","adults":"quizTwo_adults__2Z6fq","babyList":"quizTwo_babyList__G+RWu"};